import ReactOnRails from 'react-on-rails'
import Authentication from '../authentication_v2/Authentication'
import NoBFCache from '../authentication_v2/NoBFCache'
import { AuthFlowProvider } from '../authentication_v2/AuthFlowProvider'
import { handlers } from '../authentication_v2/handlers/api'

const AuthenticationV2 = ({
  recaptchaSiteKey,
  initialError,
  loginHint,
  returnUrl,
  clubId,
  logoUrl,
  csrfToken,
  forcePkEnroll,
  captchaBypass,
  customDomain,
  ...props
}) => (
  <NoBFCache>
    <AuthFlowProvider
      {...{
        handlers,
        recaptchaSiteKey,
        initialError,
        loginHint,
        returnUrl,
        clubId,
        logoUrl,
        csrfToken,
        forcePkEnroll,
        captchaBypass,
        customDomain,
      }}
    >
      <Authentication {...props} />
    </AuthFlowProvider>
  </NoBFCache>
)

ReactOnRails.register({
  AuthenticationV2,
})
